import { supabase } from "@/lib/supabase";

export const useTaskNotifications = () => {
  const createNotification = async (
    taskId: string, 
    userEmail: string, // Changed from userId to userEmail since we're getting email
    title: string,
    isUpdate: boolean = false
  ) => {
    try {
      // First, get the user's ID from their email
      const { data: userData, error: userError } = await supabase
        .from('profiles')
        .select('id')
        .eq('email', userEmail)
        .single();

      if (userError) {
        console.error('Fejl ved hentning af bruger:', userError);
        return;
      }

      if (!userData) {
        console.error('Ingen bruger fundet med email:', userEmail);
        return;
      }

      // Now create the notification with the correct UUID
      const { error } = await supabase
        .from('notifications')
        .insert([{
          user_id: userData.id,
          title: isUpdate ? "Opgave opdateret" : "Ny opgave tildelt",
          message: `Du er blevet ${isUpdate ? 'tildelt en opdateret opgave' : 'tildelt en ny opgave'}: ${title}`,
          type: isUpdate ? 'task_updated' : 'task_assigned',
          task_id: taskId
        }]);

      if (error) {
        console.error('Fejl ved oprettelse af notifikation:', error);
      }
    } catch (error) {
      console.error('Uventet fejl ved oprettelse af notifikation:', error);
    }
  };

  return { createNotification };
};